<template>
  <div class="competition">
    <v-banner single-line color="primary" :class="`${competitionClass()}`">
      <span class="open-modal-link" v-html="messageText"> </span>
    </v-banner>
  </div>
</template>

<script>
import { HOME_QUERY } from "../../constants/graphql/home";

export default {
  name: "CompetitionBanner",
  data() {
    return {
      dialog: false,
      home: {},
      currentPath: '/'
    };
  },
  watch: {
    '$route'(to, from) {
      this.currentPath = to.path;
    }
  },
  computed: {
    hasCompetition() {
      return this.home?.competition?.competitionActive;
    },
    messageText() {
      if (this.home?.competition?.referAFriendText) {
        return this.home?.competition?.referAFriendText;
      }
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    competitionClass() {
      if (this.currentPath === "/") {
        return "competition-landing-page";
      } else {
        return "competition-global";
      }
    },
  },
  apollo: {
    home: {
      query: HOME_QUERY,
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>

<style lang="scss">
.competition {
  .competition-landing-page {
    margin-top: 30px;
  }
  .competition-global {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .open-modal-link {
    // color: rgba(0, 0, 0, 0.87);
    color: white;
    display: block;
    text-align: center;
    white-space: initial;
  }

  .v-banner__actions {
    max-width: 50px;
    margin-left: 20px;
  }
}
</style>
